<template>
  <div>
    <v-card class="pl-5 pr-5">
      <h1>Licenses status</h1>
      <v-divider></v-divider>
      <v-simple-table>
        <template v-slot:default>
          <tbody>
            <tr>
              <td>Publications</td>
              <td>{{ selectedObj.publication.Title }}</td>
            </tr>
            <tr>
              <td>User</td>
              <td>{{ selectedObj.user.firstName }}</td>
            </tr>
            <tr>
              <td>Type</td>
              <td>{{ selectedObj.subscriptionType }}</td>
            </tr>
            <tr>
              <td>Date</td>
              <td>{{ selectedObj.transactionDate | formatDate }}</td>
            </tr>
            <tr>
              <td>Start Date</td>
              <td>{{ selectedObj.startDate | formatDate }}</td>
            </tr>
            <tr>
              <td>End Date</td>
              <td>{{ selectedObj.endDate | formatDate }}</td>
            </tr>
            <!--
            <tr>
              <td>Status</td>
              <td>{{ selectedObj.status }}</td>
            </tr> -->
            <tr v-show="isEnableDownload">
              <td>LCPL Url</td>
              <td>{{ LCPLjsonData }}</td>
            </tr>
            <tr v-show="isEnableDownload">
              <td colspan="2">
                <v-btn
                  depressed
                  color="primary"
                  @click="downlodaLCPL(selectedObj)"
                  id="btnDownload"
                >
                  <v-icon dark> mdi-download</v-icon> &nbsp; LCPL
                </v-btn>
                <br />
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
  </div>
</template>
<script>
import Notification from "@/components/Notification";
import * as api from "@/api";
import config from "./../api/api.config";
const fs = require("fs");
import { mapActions } from "vuex";

export default {
  name: "licensesStatus",
  components: {
    Notification,
  },
  created() {
    let url = window.location.pathname;
    if (url.includes("/licensesStatus/license"))
    {
        this.isEnableDownload = false;
        this.getLeftMenuCollapse(true);
        this.getPurchaseStatusByLicenseID(this.$route.params.id);
    }
    else {
      this.isEnableDownload = true;
      this.getPurchaseStatus(this.$route.params.id); }
  },
  methods: {
    ...mapActions(["getLeftMenuCollapse"]),
    getPurchaseStatus(id) {
      new Promise((resolve, reject) => {
        api
          .getByID("user-license", id)
          .then((response) => {
            resolve(response);
            console.log(response.data);
            this.selectedObj = response.data;
            this.LCPLjsonData =
              config.baseUrl() +
              "/licenses/download/" +
              this.selectedObj.license_uuid;
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getPurchaseStatusByLicenseID(id) {
      new Promise((resolve, reject) => {
        api
          .getByID("user-license/license", id)
          .then((response) => {
            resolve(response);
            console.log(response.data);
            this.selectedObj = response.data;
            this.LCPLjsonData =
              config.baseUrl() +
              "/licenses/download/" +
              this.selectedObj.license_uuid;
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    downlodaLCPL(obj) {
      new Promise((resolve, reject) => {
        api
          .getByID("licenses/download", this.selectedObj.license_uuid)
          .then((response) => {
            console.log(response.data);
            this.saveLCPLFile(response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    saveLCPLFile(data) {
      var fileURL = window.URL.createObjectURL(
        new Blob([JSON.stringify(data)])
      );
      var fileLink = document.createElement("a");

      fileLink.href = fileURL;
      fileLink.setAttribute(
        "download",
        this.selectedObj.license_uuid + ".lcpl"
      );
      document.body.appendChild(fileLink);

      fileLink.click();
    },
  },
  data() {
    return {
      selectedObj: {},
      LCPLjsonData: "",
      isEnableDownload : false
    };
  },
};
</script>
<style scoped>
.icon-edit {
  color: #1975d2;
}
.icon-delete {
  color: red;
}
.col {
  padding: 8px;
}
</style>



// WEBPACK FOOTER //
// src/views/licensesStatus.vue